import { Dropdown, Table } from "antd";
import TableWrapper from "../../Components/TableWrapper";

import { ColumnsType } from "antd/es/table";
import { ItemType } from "antd/es/menu/hooks/useItems";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "../../../../../redux/actions/modal";
import useLoanApplicationConvenants from "../../../../../custom-hooks/useLoanApplicationConvenants";
import { useLocation } from "react-router-dom";
import { ReactComponent as Ellipses } from "../../../../../assets/svg/icons/dots-v.svg";
import { addSerialNumber } from "../../util";
import { useState } from "react";
import * as ajaxEndpoints from "../../../../../api/ajax-endpoints";
import ConfirmationModal from "../../../../../NewComponents/ConfirmationModal";
import { appInsights } from "../../../../../config/appInsights";
import { deleteData } from "../../../../../newApis/dotNetApiMethods";

import styles from "./LoanConvenants.module.scss";
import { RootState } from "../../../../../redux/store";
import { ROLE_TYPES } from "../../../../../helpers/roleTypes";

const LoanConvenants = ({ data: loanApplication }: any) => {
  const [isShowConfirmationModal, setIsShowConfirmationModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>();
  const [error, setError] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const { loggedInUser } = useSelector(
    (state: RootState) => state?.authReducer
  );
  const dispatch = useDispatch();

  const location = useLocation();
  const state = location?.state as {
    id: number;
  };

  const {
    data: loanConvenants,
    refetch,
    isLoading,
  } = useLoanApplicationConvenants(state?.id);

  const handleEditConditions = (_data: any) => {
    dispatch(
      showModal({
        modalIdentifier: "createloanspecificconvenants",
        dataRecord: {
          refetchData: refetch,
          type: "edit",
          data: loanApplication,
          oldData: _data,
        },
      })
    );
  };

  const handleDeleteConditons = (_data: any) => {
    setIsShowConfirmationModal(true);
    return setSelectedRecord(_data);
  };

  const items: ItemType[] = [
    {
      key: "edit",
      label: "Edit",
      disabled:
        loggedInUser?.roles &&
        loggedInUser?.roles?.length > 0 &&
        !loggedInUser?.roles?.includes(ROLE_TYPES.CREDIT_APPRAISAL),
    },
    {
      key: "delete",
      label: "Delete",
      disabled:
        loggedInUser?.roles &&
        loggedInUser?.roles?.length > 0 &&
        !loggedInUser?.roles?.includes(ROLE_TYPES.CREDIT_APPRAISAL),
    },
  ];

  const columns: ColumnsType<any> = [
    {
      title: "S/N",
      dataIndex: "serialNumber",
      key: "serialNumber",
      align: "center",
    },
    {
      title: "Covenant",
      dataIndex: "covenant",
      key: "covenant",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      width: 100,
      render: (_, _data) => (
        <Dropdown
          menu={{
            items,
            onClick: ({ key }) => {
              if (key === "edit") {
                handleEditConditions(_data);
              }

              if (key === "delete") {
                handleDeleteConditons(_data);
              }
            },
          }}
        >
          <button className="btn cursor-pointer" type="button">
            <Ellipses />
          </button>
        </Dropdown>
      ),
    },
  ];

  const handleAddConvenants = () => {
    dispatch(
      showModal({
        modalIdentifier: "createloanspecificconvenants",
        dataRecord: {
          refetchData: refetch,
          type: "create",
          data: loanApplication,
        },
      })
    );
  };

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      const response = await deleteData(
        `${ajaxEndpoints.LOAN_APPLICATION_CONVENANTS}/${selectedRecord?.id}`
      );
      if (response?.data?.status === true) {
        setIsShowConfirmationModal(false);
        dispatch(
          showModal({
            modalIdentifier: "feedback",
            dataRecord: { type: "success", message: response?.data?.message },
          })
        );
        refetch();
      } else {
        setError(response?.data?.message);
      }
    } catch (error: any) {
      setError(error?.response?.data?.message);
      appInsights.trackException({
        exception: error,
        properties: { fileName: "(LoanConvenants/index.tsx)" },
      });
    }
    setIsDeleting(false);
  };

  return (
    <div className="col-xs-12 col-sm-12 col-md-10 col-lg-10">
      <div className="d-flex justify-content-end w-100 pr-3 mb-3">
        <button
          className="btn advancly-btn btn-md m-0"
          onClick={handleAddConvenants}
        >
          Add Covenants
        </button>
      </div>
      <div className="col-sm-12">
        <TableWrapper>
          <Table
            columns={columns}
            loading={isLoading}
            dataSource={addSerialNumber(loanConvenants?.data?.data)}
            // scroll={{ x: 1300 }}
            pagination={false}
            rowKey={(record) => record?.id}
          />
        </TableWrapper>
      </div>

      {isShowConfirmationModal && (
        <ConfirmationModal
          isOpen={isShowConfirmationModal}
          onClose={() => {
            setIsShowConfirmationModal(false);
          }}
          onConfirm={() => {
            handleDelete();
          }}
          error={error}
          isLoading={isDeleting}
        />
      )}
    </div>
  );
};

export default LoanConvenants;
